import { render, staticRenderFns } from "./CandidateCounter.vue?vue&type=template&id=49652102&scoped=true&"
import script from "./CandidateCounter.vue?vue&type=script&lang=js&"
export * from "./CandidateCounter.vue?vue&type=script&lang=js&"
import style0 from "./CandidateCounter.vue?vue&type=style&index=0&id=49652102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49652102",
  null
  
)

export default component.exports